export class TowerModel {
    constructor(public id: string, public name: string) {}
}